import React from 'react';
import SMReservationHelper from 'components/helpers/SMReservationHelper';
import SMReservationStatusView from '../../shared/SMReservationStatusView';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMConst from 'lib/SMConst';

class SMOReservationListTableRow extends React.Component {

  didSelect(e){
    if(this.props.delegate && typeof this.props.delegate.tableDidSelectRowAtIndex === 'function'){
      this.props.delegate.tableDidSelectRowAtIndex(this.props.rowIndex, e);
    }
  }

  render() {
    const reservation = this.props.reservation;
    let className = "dashboard-sidecol__scrollarea-list";
    const corpName = reservation.user ? reservation.user.corp_name || "" : "";
    const priceText = reservation.billing ? reservation.billing.price_both_text : "";
    if (this.props.isCurrent) className += ' is-current';

    if (SMReservationHelper.isImportedSchedule(reservation)) {
      return (
        <li className={className}>
          <a href={reservation.url}
            target={this.props.target}
            className="js-push-state dashboard-sidecol__scrollarea-list-link">
            <p className="reserve-list__id">{I18n.t("dashboard.label_000093")}：-</p>
            <p className='reserve-list__status reserve-status-icon'>{I18n.t("dashboard.label_000156")}</p>
            <p className="reserve-list__date">{reservation.reserved_date_text}</p>
            <p className="reserve-list__name">{reservation.title}</p>
            <p className="reserve-list__space">{reservation.room_name}</p>
          </a>
        </li>
      );
    } else if (SMReservationHelper.isBlockSchedule(reservation)) {
      return (
        <li className={className}>
          <a href={Routes.edit_owner_dashboard_block_path(this.props.owner.username, reservation.id)}
            className="js-push-state dashboard-sidecol__scrollarea-list-link">
            <p className="reserve-list__id">{I18n.t("dashboard.label_000093")}：-</p>
            <p className='reserve-list__status reserve-status-icon'>{I18n.t("dashboard.label_000158")}</p>
            <p className="reserve-list__date">{reservation.reserved_date_text}</p>
            <p className="reserve-list__space">{SMFormatHelper.roomName(reservation.room)}</p>
          </a>
        </li>
      );
    } else {
      var badge = null;
      if (!reservation.is_read_message) {
        className += ' is-unread';
        badge = <i className="fa fa-circle reserve-list__badge" />;
      }
      let directIcon = "";
      if (reservation.is_direct) {
        directIcon = <i className="fa fa-bolt mr5 icon-direct"></i>;
      }
      return (
        <li className={className}>
          <a href={Routes.owner_dashboard_reservation_path(this.props.owner.username, reservation.uid)}
            onClick={this.didSelect.bind(this)}
            target={this.props.target}
            className="js-push-state dashboard-sidecol__scrollarea-list-link">
            <p className="reserve-list__id">{badge}{I18n.t("dashboard.label_000093")}：{reservation.id}</p>
            <SMReservationStatusView reservation={reservation} className="reserve-list__status reserve-status-icon" />
            <p className="reserve-list__date">{SMRenderHelper.renderReservationIcon(reservation)}{reservation.reserved_date_text}</p>
            <img src={SMFormatHelper.userImageUrl(reservation.user, reservation.user.profile_image)} className="reserve-list__img" alt={SMFormatHelper.userNameWithReservation(reservation)} />
            <p className="reserve-list__name">{directIcon}{reservation.user.contact_name}</p>
            <p className="reserve-list__company">{reservation.user.corp_name}</p>
            <p className="reserve-list__space">{SMFormatHelper.roomName(reservation.room)}</p>
            <p className="reserve-list__price">{priceText}</p>
          </a>
        </li>
      );
    }
  }
}

SMOReservationListTableRow.defaultProps = {
  rowIndex: 0,
  target: "_self",
  isCurrent: false,
};

export default SMOReservationListTableRow;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOReservationListTableRow.jsx